import { FaMobileAlt } from 'react-icons/fa';
import { usePWAInstall } from '../../hooks/usePWAInstall';
import { Container } from './style';

export default function PWAInstallButton() {
  const { canInstall, install } = usePWAInstall();

  if (!canInstall) {
    return null;
  }

  return (
    <Container onClick={install}>
      <FaMobileAlt size={16} />
      <span>Instalar App</span>
    </Container>
  );
} 